import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import PriceDetail from 'modules/billing/components/PriceDetail'
import { formatPrice } from 'modules/billing/lib/f25Prices'
import { DEFAULT_CURRENCY } from 'modules/onboarding/lib/pricing/plans/utils'

import { useF25PricingContext } from '../../../../../onboarding/components/Pricing/F25PricingContext'
import * as styles from '../../index.vanilla.css'
import PeriodAndEmployeeSelector from '../_PeriodAndEmployeeSelector'
import OrderSummary from './_OrderSummary'

const SummaryCard = () => {
  const { allPlans, getSubscriptionItems, isSelfServedSegment, computeTotalPrice, isYearly } =
    useF25PricingContext()
  const currency = allPlans.f25Plans[0]?.pricing?.currency || DEFAULT_CURRENCY
  const totalPrice = computeTotalPrice()

  const commonProps = {
    bundleSubscriptionItems: getSubscriptionItems(),
    disableButton: false,
  }

  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      gap="s24"
      width="full"
    >
      <Box>
        <Box padding="s24" paddingBottom="s0">
          <Box alignItems="center" flexDirection="row" justifyContent="spaceBetween">
            <Text size="400" color="grey1000" weight="medium">
              {i18n.t('pricing_plans.total_amount')}
            </Text>
          </Box>
          <Box gap="s4" paddingTop="s16">
            <Text.Header1
              weight="semibold"
              className={isSelfServedSegment ? '' : styles.blurredText}
            >
              {formatPrice(totalPrice, currency)}
            </Text.Header1>
            {isYearly() ? (
              <Text size="300" color="grey800">
                {i18n.t('pricing_plans.price_year', { currency })}
              </Text>
            ) : (
              <Text size="300" color="grey800">
                {i18n.t('pricing_plans.price_month', { currency })}
              </Text>
            )}
          </Box>
        </Box>
        <PeriodAndEmployeeSelector />
        <PriceDetail.F25Trial {...commonProps} showContactSalesButton={!isSelfServedSegment}>
          <Box gap="s24" paddingTop="s0">
            <OrderSummary currency={currency} />
          </Box>
        </PriceDetail.F25Trial>
      </Box>
    </Box>
  )
}

export default SummaryCard
